const CheckboxFilterComponent = {
    templateUrl: '/ui/advancedFilter/component/checkboxFilter/checkboxFilter.tpl.html',
    controller: 'checkboxFilterController',
    bindings: {
        criterionTemplate: '<',
        advancedFilterType: '<',
        translationsKey: '<?'
    }
};

angular.module('umCore')
    .component('uiCheckboxFilter', CheckboxFilterComponent);
